"use client";

import {useTranslation} from "react-i18next";
import FrozenValue from "./FrozenValue";
import type {UseCaseStep} from "./useCaseSnapshot";

interface FrozenStepProps {
   step: UseCaseStep;
   scriptNames?: ReadonlyMap<string, string>;
   hideId?: boolean;
   descriptionContent?: React.ReactNode;
}

/** A step reads as its text, with its type and text script as tags when they say something. */
export default function FrozenStep({step, scriptNames, hideId = false, descriptionContent}: FrozenStepProps) {
   const {t} = useTranslation("ask");
   const {description, type, textScriptId, ...rest} = step;
   if (hideId) delete rest.id;
   const showType = type !== undefined && type !== "default";
   const showScript = textScriptId !== undefined && textScriptId !== null;
   return <div className="space-y-1.5">
      {descriptionContent ?? <FrozenValue value={description} />}
      {(showType || showScript) && <div className="flex flex-wrap gap-1.5 text-xs text-600">
         {showType && <span className="rounded bg-100 px-2 py-0.5"><FrozenValue value={type} field="type" /></span>}
         {showScript && <span className="rounded bg-100 px-2 py-0.5">
            {t("toolApproval.fields.textScriptId")}: <FrozenValue value={textScriptId} field="textScriptId" scriptNames={scriptNames} />
         </span>}
      </div>}
      {Object.keys(rest).length > 0 && <FrozenValue value={rest} field="actions" scriptNames={scriptNames} />}
   </div>;
}
